import { Delete, Tabs } from "../shared";
import ViewBasicLoginConfig from "./ViewBasicLoginConfig";
import UpdateBasicLoginConfig from "./UpdateBasicLoginConfig";
import { DELETE_BASIC_LOGIN_CONFIG } from "./query";

const SubComponent = ({ data }) => {
    const { id } = data;

    return (
        <Tabs
            tabItems={[
                {
                    id: `view-${id}`,
                    name: "View Basic Login Config",
                    content: <ViewBasicLoginConfig data={data} />,
                },
                {
                    id: `update-${id}`,
                    name: "Update Basic Login Config",
                    content: <UpdateBasicLoginConfig data={data} />,
                },
                {
                    id: `delete-${id}`,
                    name: "Delete Basic Login Config",
                    content: (
                        <Delete
                            id={id}
                            title="Basic Login Config"
                            query={DELETE_BASIC_LOGIN_CONFIG}
                            cacheName="allBasicAuths"
                        />
                    ),
                },
            ]}
        />
    );
};

export default SubComponent;
